import { Component, inject } from '@angular/core';
import { AgaveService } from 'tq-agave';
import { TqApp } from './tq-apps.types';
import { GlobalsService } from '../../globals.service';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-tq-apps',
  imports: [MatTooltip],
  templateUrl: './tq-apps.component.html'
})
export class TqAppsComponent {

    private agaveService = inject(AgaveService);

    shortcutItems: TqApp[];

    constructor() {
        this.shortcutItems = GlobalsService.tqApps;
    }

    checkClearance(item: TqApp): boolean {
        let isOk = true;
        if (item.clearance) {
            isOk = this.agaveService.getBooleanParameterValue(item.clearance) ?? false;
        }
        return isOk;
    }

    getUrl(item: TqApp): string {
        let url = '';
        if (item.url.includes('{{ticket}}')) {
            url = item.url.replace('{{ticket}}', this.agaveService.ticket);
        } else {
            url = item.url + this.agaveService.ticket + '/' + '1';
        }
        return url;
    }
}
